import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Typography } from "@mui/material";

export const MyTimesheetCalendarDayHeader = ({
  date,
}: {
  date: string | Date;
}) => {
  const { i18n } = useTranslation();
  let label = moment(date).locale(i18n.language).format("dddd");

  return (
    <Box
      height="45px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography
        sx={{
          fontSize: 16,
          textTransform: "capitalize",
          letterSpacing: 0.4,
          paddingTop: 4,
          paddingBottom: 4,
          fontWeight: "normal",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default MyTimesheetCalendarDayHeader;
